var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "store empty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "169.961462%",
    y1: "-324.053889%",
    x2: "38.5316377%",
    y2: "125.542689%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44C0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9F9F0",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73,23.8139535 L47,23.8139535 L47,29.9069767 L41,29.9069767 L41,23.8139535 L36,23.8139535 C32.6862915,23.8139535 30,21.127662 30,17.8139535 L30,6 C30,2.6862915 32.6862915,-2.79460044e-16 36,-8.8817842e-16 L84,-8.8817842e-16 C87.3137085,-1.4968968e-15 90,2.6862915 90,6 L90,17.8139535 C90,21.127662 87.3137085,23.8139535 84,23.8139535 L79,23.8139535 L79,29.9069767 L73,29.9069767 L73,23.8139535 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 15,
    y: 21,
    width: 90,
    height: 60
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4998017,59.75 C33.4998017,61.8228125 31.8226586,63.5 29.7499009,63.5 C27.6771432,63.5 26,61.8228125 26,59.75 C26,57.6771875 27.6771432,56 29.7499009,56 C31.8226586,56 33.4998017,57.6771875 33.4998017,59.75 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.996827,118.25 L0,118.25 C0,112.039062 5.03892927,107 11.2497026,107 L108.747125,107 C114.957898,107 119.996827,112.039063 119.996827,118.25 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "resized-illustrations_version-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "store-empty"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    x: 0,
    y: 0,
    width: 300,
    height: 300
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.254584,151.741573 C264.589504,212.19705 215.411011,261 154.842324,261 C93.8595457,261 44.4232365,211.527465 44.4232365,150.5 C44.4232365,145.447329 44.7621099,140.473863 45.4183532,135.601124 L10.9325843,135.601124 C5.44696945,135.601124 1,131.154154 1,125.668539 C1,120.182925 5.44696945,115.735955 10.9325843,115.735955 L49.9985591,115.735955 L89.0798639,115.735955 C94.5654787,115.735955 99.0124481,111.288986 99.0124481,105.803371 C99.0124481,101.536153 96.3215139,97.8974372 92.543996,96.491573 C91.4654202,96.8929824 90.2982612,97.1123596 89.0798639,97.1123596 L43.1898457,97.1123596 C37.7042309,97.1123596 33.2572614,92.6653901 33.2572614,87.1797753 C33.2572614,81.6941605 37.7042309,77.247191 43.1898457,77.247191 L72.1710885,77.247191 C92.4001989,54.4006708 121.940764,40 154.842324,40 C202.299058,40 242.763324,69.9602512 258.37869,112.011236 L290.067416,112.011236 C295.553031,112.011236 300,116.458205 300,121.94382 C300,127.429435 295.553031,131.876404 290.067416,131.876404 L263.699818,131.876404 L241.69607,131.876404 C236.210455,131.876404 231.763485,136.323374 231.763485,141.808989 C231.763485,147.294604 236.210455,151.741573 241.69607,151.741573 L265.254584,151.741573 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(90.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M73.5,29.4069767 L78.5,29.4069767 L78.5,23.3139535 L84,23.3139535 C87.0375661,23.3139535 89.5,20.8515196 89.5,17.8139535 L89.5,6 C89.5,2.96243388 87.0375661,0.5 84,0.5 L36,0.5 C32.9624339,0.5 30.5,2.96243388 30.5,6 L30.5,17.8139535 C30.5,20.8515196 32.9624339,23.3139535 36,23.3139535 L41.5,23.3139535 L41.5,29.4069767 L46.5,29.4069767 L46.5,23.3139535 L73.5,23.3139535 L73.5,29.4069767 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(0.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-68"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#64808C",
    strokeWidth: 1,
    x: 15.5,
    y: 21.5,
    width: 89,
    height: 59
  })), /*#__PURE__*/React.createElement("g", {
    id: 33558,
    fill: "#87D5FA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49317923,30 C9.91749013,30 12.2904743,28.8372093 13.7405141,26.6860465 L15.3517996,24.2876744 C16.1575595,27.5362791 18.9772506,30 22.5000481,30 C26.6455635,30 29.9998498,26.6713953 29.9998498,22.5581395 C29.9998498,26.6716279 33.3543705,30 37.4996515,30 C41.6449325,30 44.9994532,26.6713953 44.9994532,22.5581395 C44.9994532,26.6716279 48.3539739,30 52.4992549,30 C56.6445359,30 59.9990566,26.6713953 59.9990566,22.5581395 C59.9990566,26.6716279 63.3533429,30 67.4988583,30 C71.6441394,30 74.99866,26.6713953 74.99866,22.5581395 C74.99866,26.6716279 78.3529464,30 82.4984617,30 C86.6439771,30 89.9982635,26.6713953 89.9982635,22.5581395 C89.9982635,26.6716279 93.3525498,30 97.4980652,30 C101.028128,30 103.840554,27.5362791 104.646314,24.2876744 L106.257599,26.6860465 C107.700374,28.8372093 110.080623,30 112.504934,30 C113.933178,30 115.375952,29.5930233 116.657715,28.75 C120.107389,26.467907 121.037599,21.845814 118.737738,18.4302326 L104.997867,0.23255814 L74.99866,0.23255814 L44.9994532,0.23255814 L15.0002464,0.23255814 L1.26037527,18.4302326 C-1.03948579,21.8460465 -0.102010579,26.4681395 3.3403984,28.75 C4.61466159,29.5930233 6.06470138,30 7.49317923,30 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Combined-Shape",
    fill: "#EB8181",
    points: "22 79 22 41 44.4994051 41 44.4994051 79"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M32.9998017,59.75 C32.9998017,57.9533269 31.5465132,56.5 29.7499009,56.5 C27.9532885,56.5 26.5,57.9533269 26.5,59.75 C26.5,61.5466731 27.9532885,63 29.7499009,63 C31.5465132,63 32.9998017,61.5466731 32.9998017,59.75 Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EB8181",
    points: "52.4990205 67.5 52.4990205 41.25 97.4978308 41.25 97.4978308 67.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M119.485392,117.749995 C119.223995,112.047095 114.514169,107.5 108.747125,107.5 L11.2497026,107.5 C5.48265874,107.5 0.772832308,112.047095 0.511435476,117.749995 L119.485392,117.75 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreEmpty);
export default __webpack_public_path__ + "static/media/store-empty.3a115613f5cf0450f4807ae83217dcc1.svg";
export { ForwardRef as ReactComponent };